import React from 'react';
import ApplicationLogo from "../../assets/Application.png";
import styled from "styled-components";
import {mdDownN} from "../../ui/common";


const ApplicationTopGroupStyle = styled.div`
    height: 185px;
    width: 600px;
    ${mdDownN`
        height: 110px;
        background: yellow;
        width: 100%;
    `}
`;

const ApplicationTopTitleGroupStyle = styled.div`
    top: 0px;
    height: 137px;
    width: 600px;
    position: absolute;
    margin: 0;
    left: 0px;
    background: linear-gradient(180deg, #48D08C 0%, #00B6B8 100%);
    ${mdDownN`
        height:110px !important;
        position: relative;
        width: 100%;
        text-align:center;
        display: flex;
        flex-direction: column;
        align-items:center;
        height:auto;
    `}
`;

const ApplicationTopTitleStyle = styled.div`
    top: 36px;
    height: 41px;
    width: 481px;
    position: absolute;
    margin: 0;
    left: 60px;
    font-family: "Stag-Medium", Helvetica, Arial, serif;
    font-size: 32.0px;
    color: #fff;
    text-align: center;
    letter-spacing: 1.0px;
    line-height: 40.0px;
    ${mdDownN`
        position: relative;
        top:auto;
        left:auto;
        width: 100%;
        margin-top:31px;
        font-size: 24px;
        font-weight: 500;
        letter-spacing: 1px;
        line-height: 36px;
        
    `}
`;

const ApplicationTopLogoStyle = styled.img`
    top: 87px;
    height: 87px;
    width: 216px;
    position: absolute;
    margin: 0;
    left: 191px;
    ${mdDownN`
        top: auto;
        position: absolute;
        left: 50%;
        width: 122px;
        height: 64px;
        transform: translate(-50%,-50%) 
    `}
`;

const ApplicationTop = (props) => {
    return (
        <ApplicationTopGroupStyle>
            <ApplicationTopTitleGroupStyle>
                <ApplicationTopTitleStyle>
                    Application
                </ApplicationTopTitleStyle>
            </ApplicationTopTitleGroupStyle>
            <ApplicationTopLogoStyle src={ApplicationLogo} />
        </ApplicationTopGroupStyle>
    );
}

export default ApplicationTop;
